module.exports = __webpack_public_path__ + "static/media/create-folder-icon.1d060506.svg";